import React, { useState } from "react";
import { TicketIcon } from "@heroicons/react/24/outline";
import { getFunctions, httpsCallable } from "firebase/functions";
import { toast } from "react-toastify";
import { useCredits } from "../../contexts/CreditsContext";

export default function CouponRedemptionPage() {
  const { credits } = useCredits();
  const [couponCode, setCouponCode] = useState('');
  const [redeeming, setRedeeming] = useState(false);

  const handleRedeemCoupon = async (e) => {
    e.preventDefault();
    const code = couponCode.trim();
    if (!code) { toast.error('Please enter a coupon code'); return; }

    setRedeeming(true);
    try {
      const functions = getFunctions();
      const redeemCoupon = httpsCallable(functions, 'redeemCoupon');
      const result = await redeemCoupon({ code });
      const awarded = result.data?.credits || 0;
      toast.success(`Coupon redeemed! ${awarded} credits added.`);
      setCouponCode('');
    } catch (err) {
      let msg = 'Failed to redeem coupon';
      if (err?.message) {
        msg = err.message;
      } else if (err?.details?.message) {
        msg = err.details.message;
      }
      toast.error(msg);
    } finally {
      setRedeeming(false);
    }
  };

  return (
    <div className="max-w-4xl">
      <h1 className="text-2xl font-bold text-gray-900 mb-8">Redeem Coupon</h1>

      {/* Current Balance */}
      <div className="bg-white border border-gray-200 rounded-lg p-6 mb-8 shadow-sm">
        <h2 className="text-lg font-medium text-gray-900 mb-4">Your current balance</h2>
        <div className="flex items-center text-3xl font-bold text-gray-900">
          <TicketIcon className="h-8 w-8 text-indigo-500 mr-2" />
          <span>{credits} credits</span>
        </div>
      </div>

      {/* Redeem Coupon Form */}
      <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
        <h2 className="text-lg font-medium text-gray-900 mb-4 flex items-center">
          <TicketIcon className="h-5 w-5 text-indigo-500 mr-2" />
          Enter your coupon code
        </h2>
        <p className="text-gray-500 text-sm mb-6">
          Have a coupon code? Enter it below to redeem your credits.
        </p>
        <form onSubmit={handleRedeemCoupon} className="flex flex-col gap-4">
          <input
            type="text"
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
            placeholder="Enter coupon code (e.g., WELCOME50)"
            className="border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            disabled={redeeming}
          />
          <button
            type="submit"
            disabled={redeeming || !couponCode.trim()}
            className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 text-white text-sm font-medium rounded-md transition-colors w-full"
          >
            {redeeming ? 'Redeeming...' : 'Redeem Coupon'}
          </button>
        </form>
      </div>
    </div>
  );
}
